export var ActivationStepType;
(function (ActivationStepType) {
    ActivationStepType["Extraction"] = "extraction";
    ActivationStepType["Authentication"] = "authentication";
    ActivationStepType["Instructions"] = "instructions";
    ActivationStepType["Timer"] = "timer";
    ActivationStepType["Memory"] = "memory";
})(ActivationStepType || (ActivationStepType = {}));
//# sourceMappingURL=activation-step-type.const.js.map